import React from 'react';
import { flashForReact } from '../../flash_react';
import { defaultHeaders } from '../../ajax_utils';

const Member = ({
  member,
  handleModalOpen,
  tab,
  communityId,
  setUpdatedMember,
  admin
}) => {
  const messageLink = (e, id) => {
    e.preventDefault();
    (window.location.href = `/conversations/new?participant_id=${id}`);
  };

  const subInfoSelect = () => {
    return (tab === 'pending') ? (
        <a
        className="mb-0 text-primary member-detail"
        data-bs-toggle="modal"
        data-bs-target="#applicationModal"
        onClick={() => handleModalOpen(member)}
      >
        View Application
        <i className="fas fa-long-arrow-alt-right ml-10 mr-10"></i>
      </a>
    )
    : '';
  };

  const handleStatus = (e, status) => {
    e.preventDefault();
    $.ajax({
      beforeSend: (xhr) => defaultHeaders(xhr),
      url: `${location.pathname}/${communityId}`,
      method: 'PATCH',
      data: { member: { status, member_id: member.id } }
    }).success((res) => {
      setUpdatedMember(res.member);
      flashForReact('notice', res.message);
    }).error((res) => {
      flashForReact('danger', res.message);
    });
  };

  const memberControlsSelect = () => {
    if (tab === 'pending') {
      return (
        <>
          <button
            className="btn-light-gray-hover btn btn-sm me-4 options d-lg-block d-xs-none d-md-none member-btn"
            id="decline-btn"
            type="button"
            onClick={(e) => handleStatus(e, 'rejected')}
          >
            Decline
          </button>
          <button
            className="btn btn-primary btn-sm px-5 member-btn"
            id="accept-btn"
            onClick={(e) => handleStatus(e, 'accepted')}
          >
            Accept
          </button>
        </>
      );
    }
    const canEdit = (member.role === 'admin' && admin) || (member.role !== 'admin');
      return (
        <>
          {canEdit &&
            <div className={`dropdown ${['declined', 'invited', 'removed', 'modal'].includes(tab) && 'd-none'}`}>
              <button
                className="btn btn-light-gray-hover dropdown-toggle btn btn-sm me-4 options d-lg-block d-xs-none d-md-none"
                type="button"
                id="dropdownMenuButton2"
                data-bs-toggle="dropdown"
                data-bs-placement="bottom"
                aria-expanded="false"
              >
                <div className="member-options">
                  <i className="fa fa-circle" aria-hidden="true"></i>
                  <i className="fa fa-circle" aria-hidden="true"></i>
                  <i className="fa fa-circle" aria-hidden="true"></i>
                </div>
              </button>
              <ul
                className="dropdown-menu dropdown-menu-outline p-0"
                aria-labelledby="dropdownMenuButton2"
                style={{ transform: 'translate(-159px, 31px) !important' }}
              >
                {admin &&
                  <li
                    data-bs-toggle="modal"
                    data-bs-target="#changeRoleModal"
                    onClick={() => handleModalOpen(member)}
                    className="border-bottom"
                  >
                    <a className="dropdown-item text-center py-4 text-dark">
                      Change role
                    </a>
                  </li>
                }
                <li
                  data-bs-toggle="modal"
                  data-bs-target="#restartSubscriptionModal"
                  onClick={() => handleModalOpen(member)}
                  className="border-bottom"
                >
                  <a className="dropdown-item text-center py-4 text-dark">
                    Restart subscription
                  </a>
                </li>
                <li
                  data-bs-toggle="modal"
                  data-bs-target="#removeMemberModal"
                  onClick={() => handleModalOpen(member)}
                >
                  <a className="dropdown-item text-center py-4 text-dark">
                    Remove from community
                  </a>
                </li>
              </ul>
            </div>
          }
          <a
            className="btn btn-primary btn-sm px-5 member-btn"
            onClick={(e) => messageLink(e, member.id)}
          >
            Message
          </a>
        </>
      );
  };

  const styles = {
    name: { fontSize: 18 },
    title: {
      fontSize: 12,
      fontWeight: 600,
      color: '#000'
    }
  };
  return (
    <div className="row member-card border-bottom py-3 px-2 px-md-0 mx-md-0 justify-content-md-between m-auto">
      <div className="headshot col-1 p-0">
        <img
          src={member.headshot}
          className="avatar border-0 rounded-circle"
          alt="Member headshot"
        />
      </div>
      <div className="col-md-6 col-11 justify-content-between m-auto">
        <div>
          <p className="h4 mb-0 d-flex align-items-center" style={tab === 'modal' ? styles.name : {}}>
            <a href={`${location.origin}/users/${member.slug}`} className="text-decoration-none text-black">
              {member.displayName}
            </a>
            {member.role === 'standard' ? <></> : <span className="ms-lg-3 badge bg-primary-soft border border-primary ms-2 fs-6 text-capitalize">
              {member.role}
            </span>}
          </p>
          <div className="d-flex justify-content-between align-items-baseline">
            <p className="mb-0 mt-n1 member-job" style={tab === 'modal' ? styles.title : {}}>
              {member.title || null}
              {member.title && member.company ? ', ' : ''}
              <span className="member-company">{member.company || null}</span>
            </p>
            <a
              onClick={(e) => messageLink(e, member.id)}
              className="fs-6 m-0 text-center text-primary d-block d-md-none"
            >
              Message
            </a>
          </div>
        </div>
        <div className="d-flex">{subInfoSelect()}</div>
      </div>
      <div className="col-lg-5 col-sm-3 pe-0 justify-content-end align-items-center d-none d-md-flex d-lg-flex d-xl-flex d-xxl-flex">
        {memberControlsSelect()}
      </div>
    </div>
  );
};

export default Member;
